import { render, staticRenderFns } from "./c-refound-detai.vue?vue&type=template&id=0d0b8083&scoped=true&"
import script from "./c-refound-detai.vue?vue&type=script&lang=js&"
export * from "./c-refound-detai.vue?vue&type=script&lang=js&"
import style0 from "./c-refound-detai.vue?vue&type=style&index=0&id=0d0b8083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b8083",
  null
  
)

export default component.exports